import React, { useState, useEffect, useContext  } from 'react';
import { Container, TextField, Button, MenuItem, Typography, Alert } from '@mui/material';
import documentoApi from '../../api/documentoApi';
import contribuenteApi from '../../api/contribuenteApi';
import { useNavigate } from 'react-router-dom';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
const DOCUMENT_TYPES = [
    'MULTA',
    'PAGOPA',
    'RATEIZZAZIONE_ADE',
    'ROTTAMAZIONE',
    'AMA',
    'ACCERTAMENTO_TARI',
    'F24',
    'FF24PREDETERMINATO',
    'TARI',
    'INTIMAZIONEPAG_AGRISC',
    'BOLLOAUTO',
    'INARCASSA',
    'ALTRO'
];
export default function DocumentoCreatePage() {
  const { user } = useContext(AuthContext);
  const [form, setForm] = useState({ tipo: '', contribuenteId: user.contribuenteId?user.contribuenteId:'' });
  const [contribuenti, setContribuenti] = useState([]);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
  if(!user.contribuenteId || user.contribuenteId==='')
    contribuenteApi.list({ page: 0, size: 1000 }).then(r => setContribuenti(r.data.content || []));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await documentoApi.create(form);
      navigate('/documenti');
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
    <Button variant="outlined" sx={{ ml: 2 }} onClick={() => navigate(`/documenti/upload/${form.id}`)}>
      Carica PDF
    </Button>
      <Typography variant="h5">Crea Documento</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField
          select
          fullWidth
          sx={{ my: 1 }}
          label="Tipo"
          value={form.tipo}
          onChange={e => setForm({ ...form, tipo: e.target.value })}
          required
        >
          {DOCUMENT_TYPES.map(t => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </TextField>
        <TextField fullWidth sx={{ my: 1 }} label="Descrizione" value={form.descrizione} onChange={e => setForm({...form, descrizione: e.target.value})} />
        <TextField select fullWidth sx={{ my: 1 }} label="Contribuente" value={form.contribuenteId} onChange={e => setForm({...form, contribuenteId: e.target.value})}>
          {contribuenti.map(c => <MenuItem key={c.id} value={c.id}>{c.nome} {c.cognome}</MenuItem>)}
        </TextField>
        <Button variant="contained" type="submit">Crea</Button>
      </form>
    </Container>
  );
}